import React, { useEffect, useState } from "react";
import {
    loadCaptchaEnginge,
    validateCaptcha,
    //@ts-ignore
} from "react-simple-captcha";
import {
    getCloseFinancialPermission,
    closeCycleRequest,
} from "Services/Financial";
import { useMutation } from "@tanstack/react-query";
import "./closeFinancialCycle.scss";
import {
    CLoseFinancialCycleProps,
    CloseFinancialInnerState,
} from "./CloseFinancial.props";
import { Button, Toast } from "components";
import CloseFinancialCycleModal from "./CloseFinancialCycleModal";

const CloseFinancialCycle: React.FC<CLoseFinancialCycleProps> = ({
    cycleId,
    updateCycleList,
    redirectToCycleList,
    className,
    title,
}) => {
    const [{ showModal, showToast, captchaMatchError }, setState] =
        useState<CloseFinancialInnerState>({
            showModal: false,
            showToast: false,
            captchaMatchError: "",
        });

    const { mutate } = useMutation(getCloseFinancialPermission, {
        onSuccess: (data) => {
            if (data.data?.status === "OK") {
                setState((prv) => ({ ...prv, showModal: true }));
            }
        },
    });
    const { mutate: closingCycle } = useMutation(
        () => closeCycleRequest(cycleId),
        {
            onSuccess: (data) => {
                if (data.data?.status === "OK") {
                    if (redirectToCycleList) {
                        redirectToCycleList();
                    }
                    if (updateCycleList) {
                        updateCycleList();
                    }
                    setState((prv) => ({
                        ...prv,
                        showModal: false,
                        showToast: true,
                    }));
                }
            },
        }
    );

    useEffect(() => {
        if (showModal) {
            loadCaptchaEnginge(6);
        }
    }, [showModal]);

    const checkPermissionForClose = () => {
        mutate(cycleId);
    };

    const handleConfirmCloseCycle = async () => {
        let user_captcha = (
            document.getElementById("user_captcha_input") as HTMLInputElement
        ).value;
        if (validateCaptcha(user_captcha)) {
            closingCycle();
        } else {
            (
                document.getElementById(
                    "user_captcha_input"
                ) as HTMLInputElement
            ).value = "";
            setState((prv) => ({
                ...prv,
                captchaMatchError: "Captcha Does Not Match",
            }));
        }
    };

    return (
        <div className={`close-financial-cycle ${className}`}>
            <Toast
                className="success"
                isShow={showToast}
                title={"دوره زمانی با موفقیت بسته شد."}
            />
            <Button
                data-testid="ToggleCloseFinancialButton"
                btnText="بستن دوره زمانی"
                className="solid is-pink"
                handleClick={checkPermissionForClose}
            />
            <CloseFinancialCycleModal
                captchaMatchError={captchaMatchError}
                showModal={showModal}
                title={title}
                onConfirm={handleConfirmCloseCycle}
                onToggleShowModal={(val) =>
                    setState((prv) => ({ ...prv, showModal: val }))
                }
            />
        </div>
    );
};

export default CloseFinancialCycle;
